import * as React from 'react'
import GTMScript from '@/scopes/common/components/Scripts/GTMScript'
import NewrelicScript from '@/scopes/common/components/Scripts/NewrelicScript'
import { Configuration } from '@/scopes/common/domain/types/configuration'
import { useFeatureFlag } from '@/scopes/common/infrastructure/feature-flags'

export function ThirdPartyScripts({ configuration }: { configuration: Configuration['thirdParties'] }) {
  const newRelicScriptName = process.env.NEXT_PUBLIC_NEWRELIC_SCRIPT_NAME
  const useTaggrsScript = useFeatureFlag('KYOTO_USE_TAGGRS_SCRIPT')
  const { gtmId } = configuration

  return (
    <>
      {!useTaggrsScript && <GTMScript gtmId={gtmId} />}
      <NewrelicScript newRelicScriptName={newRelicScriptName!} />
    </>
  )
}
